var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('t-form-item',{attrs:{"label":_vm.schema.text,"prop":_vm.schema.propertyName,"required":_vm.schema.required,"important":_vm.schema.important}},[_c('t-email-sender-input',{attrs:{"value":_vm.value},on:{"input":v => _vm.$emit('input', v)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }